import { lexonHttp } from '@/plugins/axios/lexonHttp'

export class FormsService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }

  deleteData(url: string) {
    return lexonHttp.delete(url)
  }
}
